<template>
  <div>
    <template>
      {{ iconForData }}
    </template>
    <template v-for="icon in icons">
      {{ icon }}
    </template>
    {{ model[prop] }}
  </div>
</template>

<script src="./CellWithIcon.script.ts" lang="ts" />
